import React from "react";
import { WA_ICON } from "./HeroCTAs";

export const WhatsAppFloat = () => (
  <a
    href="https://wa.me/33745449641?text=Bonjour%20Ma%C3%AEtre%20Diamma,%20je%20souhaite%20une%20consultation"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Contacter Maître Diamma sur WhatsApp"
    data-testid="whatsapp-float-button"
    className="fixed z-50 right-4 bottom-4 sm:right-6 sm:bottom-6 w-14 h-14 rounded-full bg-emerald-500 hover:bg-emerald-400 text-white flex items-center justify-center shadow-xl shadow-emerald-600/40 transition-transform duration-300 hover:scale-110"
    style={{ marginBottom: "env(safe-area-inset-bottom)" }}
  >
    <span className="absolute inset-0 rounded-full bg-emerald-500/60 animate-ping" style={{ animationDuration: "2.5s" }} />
    <svg className="relative w-7 h-7" viewBox="0 0 24 24" fill="currentColor"><path d={WA_ICON} /></svg>
  </a>
);
